/*
  This Saga observes when the user links/unlinks offer(s) or adds/removes card(s) and clears the current
  Instore offers cache to ensure updated data is fetched from the API on the next page refresh
*/
import { takeEvery } from 'redux-saga/effects';
import LocalStorageCache from 'core/utils/cache/localStorage';
import SessionStorageCache from 'core/utils/cache/sessionStorage';
import { cacheStorageCache } from 'core/utils/cache/cacheStorage';
import {
  MEMBER_POST_INSTORE_CARD_LINK, MEMBER_DELETE_INSTORE_PAYMENT_CARD,
  MEMBER_DELETE_INSTORE_OFFER_CARD_LINK, MEMBER_POST_INSTORE_MULTI_OFFER_CARD_LINK,
} from 'core/actions/member';
import { INSTORE_CARD_ADDITION_COMPLETED, INSTORE_NEW_CARD_ADD_FAILED } from 'core/modules/Instore2/actions/types';
import { INSTORE_OFFERS_CACHE_ID } from 'core/modules/Instore2/utils/constants';

const localStorageCache = new LocalStorageCache();
const sessionStorageCache = new SessionStorageCache();

const cacheList = [localStorageCache, sessionStorageCache, cacheStorageCache];

function handleInstoreCache() {
  cacheList.forEach((cache) => cache.clearById(INSTORE_OFFERS_CACHE_ID));
}

const cacheClearTriggers = [
  MEMBER_POST_INSTORE_CARD_LINK,
  MEMBER_DELETE_INSTORE_OFFER_CARD_LINK,
  MEMBER_POST_INSTORE_MULTI_OFFER_CARD_LINK,
  MEMBER_DELETE_INSTORE_PAYMENT_CARD,
  INSTORE_CARD_ADDITION_COMPLETED,
  INSTORE_NEW_CARD_ADD_FAILED,
];

export default function* onCacheSaga() {
  yield takeEvery(cacheClearTriggers, handleInstoreCache);
}
